import StripeActions from "actions/StripeActions";

const {
  CREATE_BILLING_PORTAL_SESSION_START,
  CREATE_BILLING_PORTAL_SESSION_DONE,
  CREATE_BILLING_PORTAL_SESSION_ERROR,
  CREATE_SETUP_CHECKOUT_SESSION_START,
  CREATE_SETUP_CHECKOUT_SESSION_DONE,
  CREATE_SETUP_CHECKOUT_SESSION_ERROR,
  CREATE_UPSELL_CHECKOUT_SESSION_START,
  CREATE_UPSELL_CHECKOUT_SESSION_DONE,
  CREATE_UPSELL_CHECKOUT_SESSION_ERROR,
  FULLFILL_CHECKOUT_SESSION_START,
  FULLFILL_CHECKOUT_SESSION_DONE,
  FULLFILL_CHECKOUT_SESSION_ERROR,
  SUBMIT_CANCELLATION_START,
  SUBMIT_CANCELLATION_DONE,
  SUBMIT_CANCELLATION_ERROR
} = StripeActions;

const initialState = {
  fetchingData: false
};

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case CREATE_BILLING_PORTAL_SESSION_START:
    case CREATE_SETUP_CHECKOUT_SESSION_START:
    case CREATE_UPSELL_CHECKOUT_SESSION_START:
    case FULLFILL_CHECKOUT_SESSION_START:
    case SUBMIT_CANCELLATION_START:
      return { ...state, fetchingData: true };

    case CREATE_BILLING_PORTAL_SESSION_DONE:
    case CREATE_SETUP_CHECKOUT_SESSION_DONE:
    case CREATE_UPSELL_CHECKOUT_SESSION_DONE:
    case FULLFILL_CHECKOUT_SESSION_DONE:
    case SUBMIT_CANCELLATION_DONE:
    case CREATE_BILLING_PORTAL_SESSION_ERROR:
    case CREATE_SETUP_CHECKOUT_SESSION_ERROR:
    case CREATE_UPSELL_CHECKOUT_SESSION_ERROR:
    case FULLFILL_CHECKOUT_SESSION_ERROR:
    case SUBMIT_CANCELLATION_ERROR:
      return { ...state, fetchingData: false };

    default:
      return state;
  }
};
